import OwnerDetails from "../../components/admin/owner-details"


const OwnerDetailsPage = () => {
    return (
        <OwnerDetails />
    )
}

export default OwnerDetailsPage;